import React, { FC } from 'react';
import styled from 'styled-components';

import { pagesMap } from '../../../constants';
import {
  AdminStudioIcon,
  BarChartIcon,
  ChartIcon,
  CompanyAssetsIcon,
  ConfigIcon,
  CustomPageIcon,
  DatabaseIcon,
  DocumentIcon,
  GroupIcon,
  HomeIcon,
  LayersIcon,
  LibraryIcon,
  PerformanceIcon,
  PersonIcon,
  TagIcon,
  TrashIcon,
} from '../NgIcons';

// Re-export icons that other parts of the app import from here
export {
  AdminStudioIcon,
  ChevronRightIcon,
  ChartIcon,
  CompanyAssetsIcon,
  CustomPageIcon,
  DatabaseIcon,
  DocumentIcon,
  FolderIcon,
  GroupIcon,
  HomeIcon,
  LayersIcon,
  LibraryIcon,
  PerformanceIcon,
  PersonIcon,
  PinIcon,
  PlusIcon,
  ProjectIcon,
  SearchIcon,
  SlideIcon,
  SlideLibraryIcon,
  SupportIcon,
  TagIcon,
  TrashIcon,
  WorkspaceIcon,
} from '../NgIcons';

const IconWrap = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.5rem;
  height: 1.5rem;
  flex-shrink: 0;

  svg {
    width: 1.5rem;
    height: 1.5rem;

    path, circle, rect, polyline, line {
      stroke-width: ${({ theme }) => theme?.size?.iconStrokeWidth ?? '1.25'};
    }
  }
`;

const iconMap: Record<string, React.ReactNode> = {
  HomeIcon: <HomeIcon />,
  LibraryIcon: <LibraryIcon />,
  CustomPageIcon: <CustomPageIcon />,
  PerformanceIcon: <PerformanceIcon />,
  TrashIcon: <TrashIcon />,
  AdminStudioIcon: <AdminStudioIcon />,
  CompanyAssetsIcon: <CompanyAssetsIcon />,
  MyAssetsIcon: <PersonIcon />,
  SharedWithMeIcon: <GroupIcon />,
  ManageUsersIcon: <PersonIcon />,
  ManageGroupsIcon: <GroupIcon />,
  WorkspaceTemplatesIcon: <DocumentIcon />,
  EntitiesIcon: <DatabaseIcon />,
  ThemesIcon: <CustomPageIcon />,
  AccountTreeOutlinedIcon: <TagIcon />,
  StarterDecksIcon: <LayersIcon />,
  ShowChartIcon: <PerformanceIcon />,
  AssessmentIcon: <BarChartIcon />,
  SettingsIcon: <ConfigIcon />,
  ChartIcon: <ChartIcon />,
};

export const getNavIconName = (slug: string): string => {
  switch (slug) {
    case 'trash':
      return 'TrashIcon';
    case 'reports':
      return 'AssessmentIcon';
    case 'home':
    case 'my-workspace':
      return 'HomeIcon';
    case pagesMap.workspaceTemplates.slug:
      return 'WorkspaceTemplatesIcon';
    case 'entities':
      return 'EntitiesIcon';
    case 'shared':
      return 'SharedWithMeIcon';
    case 'users':
      return 'ManageUsersIcon';
    case 'groups':
      return 'ManageGroupsIcon';
    case 'my-assets':
      return 'MyAssetsIcon';
    case 'settings':
      return 'SettingsIcon';
    case 'company-assets':
      return 'CompanyAssetsIcon';
    case 'themes':
      return 'ThemesIcon';
    case 'starter-decks':
      return 'StarterDecksIcon';
    case pagesMap.categories.slug:
      return 'AccountTreeOutlinedIcon';
    case 'chart':
      return 'ChartIcon';
    default:
      return 'LibraryIcon';
  }
};

interface Props {
  icon: string | React.ReactNode;
}

export const NgSideNavIcon: FC<Props> = ({ icon }) => {
  const node = typeof icon === 'string' ? iconMap[icon] ?? <LibraryIcon /> : icon;
  return <IconWrap>{node}</IconWrap>;
};
